import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StoryblokIcon } from "@cinch-nx/landing-ui-shared";
import styles from "./ev-info-card.module.css";
export const EvInfoCard = ({ evInfo  })=>{
    const { icon , title , text  } = evInfo[0];
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.cardContainer,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.iconTitleContainer,
                children: [
                    /*#__PURE__*/ _jsx(StoryblokIcon, {
                        iconName: icon,
                        size: 24
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("p", {
                className: styles.text,
                children: text
            })
        ]
    });
};
